import React from "react";
import AppHeader from "@/components/AppHeader";
import HomeSwipe from "@/components/HomeSwipe";

/**
 * Landing = solo la sequenza swipe (no scroll verticale lungo).
 * All'apertura l'utente vede subito la schermata visuale principale.
 * La navigazione tra le schermate della Home è manuale (swipe / freccia).
 */
export default function Landing() {
  return (
    <div className="min-h-screen bg-[#F7F5F0] flex flex-col overflow-hidden" data-testid="landing-page">
      <AppHeader />
      <main className="flex-1 flex" data-testid="landing-main">
        <HomeSwipe />
      </main>
    </div>
  );
}
